// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyItem_wrapper__4g+gx","copy":"CopyItem_copy__zPWkb"};